/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BattleStats, BattleStatsInterface } from "../BattleStats";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorType",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorValue",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToTiers",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToStatBase",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BattleStats__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BattleStats> {
    return super.deploy(overrides || {}) as Promise<BattleStats>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BattleStats {
    return super.attach(address) as BattleStats;
  }
  connect(signer: Signer): BattleStats__factory {
    return super.connect(signer) as BattleStats__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BattleStatsInterface {
    return new utils.Interface(_abi) as BattleStatsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BattleStats {
    return new Contract(address, _abi, signerOrProvider) as BattleStats;
  }
}
